import { useState, useEffect, useRef } from "react";
import { checkFormError, isObjectValueEmpty } from "./index";

/**
 * Custom hook for form validation and state management
 * @param {Object} initialValues - Initial form values
 * @param {Object} initialErrors - Initial error state
 * @param {Object} schema - Yup validation schema
 * @returns {Object} Form state and handlers
 */
export const useFormValidation = (initialValues, initialErrors, schema) => {
  const [inputValue, setInputValue] = useState(initialValues);
  const [inputError, setInputError] = useState(initialErrors);

  const handleInputChange = async (name, value) => {
    const nextValue =
      name === "email" && typeof value === "string"
        ? value.toLowerCase()
        : value;
    const stateObj = { ...inputValue, [name]: nextValue };
    setInputValue(stateObj);

    if (isObjectValueEmpty(inputError)) {
      const error = await checkFormError(stateObj, schema);
      setInputError(
        error === true ? { ...initialErrors } : { ...initialErrors, ...error }
      );
    }
  };

  const validateForm = async () => {
    const validationResult = await checkFormError(inputValue, schema);
    if (validationResult === true) {
      return true;
    }
    setInputError({ ...initialErrors, ...validationResult });
    return false;
  };

  const resetForm = () => {
    setInputValue(initialValues);
    setInputError(initialErrors);
  };

  return {
    inputValue,
    inputError,
    setInputValue,
    setInputError,
    handleInputChange,
    validateForm,
    resetForm,
  };
};

export const useTimerCount = () => {
  const Ref = useRef(null);
  const Ref1 = useRef(null);
  const [timer, setTimer] = useState("0");
  const [timer1, setTimer1] = useState("0");

  const getTimeRemaining = (e) => {
    const total = Date.parse(e) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    return { total, seconds };
  };

  const startTimer = (e, setFun) => {
    let { seconds, total } = getTimeRemaining(e);
    if (total >= 0) {
      setFun(+seconds);
    }
  };

  const clearTimer = (e, setFun, ref) => {
    setFun("0");
    if (ref.current) clearInterval(ref.current);
    const id = setInterval(() => {
      startTimer(e, setFun);
    }, 1000);
    ref.current = id;
  };

  const getDeadTime = () => {
    let deadline = new Date();

    deadline.setSeconds(deadline.getSeconds() + 30);
    return deadline;
  };

  useEffect(() => {
    clearTimer(getDeadTime(), setTimer1, Ref1);
    clearTimer(getDeadTime(), setTimer, Ref);
  }, []);

  const resetTimer = (action) => {
    if (action === 1) clearTimer(getDeadTime(), setTimer, Ref);
    if (action === 2) clearTimer(getDeadTime(), setTimer1, Ref1);
  };

  return { timer, timer1, resetTimer };
};
